import loadable from '@loadable/component';

/**
 * Code-split wrapper for AutoPopModalContainer — keeps it out of the initial bundle; it renders nothing at
 * first paint. Jest maps `*.loadable` modules to their eager originals (see jest.config.cjs).
 */
const AutoPopModalContainer = loadable(
    /* #__LOADABLE__ */
    () => import('./AutoPopModalContainer'),
    {
        ssr: false,
    }
);

export default AutoPopModalContainer;
